import { ROSTER_STATUSES } from '../constants';

export default class RosterUtils {
  constructor(Authentication, Utils, TimesheetsUtils) {
    'ngInject';

    Object.assign(this, { Authentication, Utils, TimesheetsUtils });
  }

  getEventStatus(event) {
    const statusTemplate = this._getStatusTemplate(event);
    const arrivalTime = this.getTimeLabel(event.clockInTime);
    const departureTime = event.clockOutTime ? this.getTimeLabel(event.clockOutTime) : '';

    let title = statusTemplate.title;
    title = title.replace('$arrivalTime', arrivalTime);
    title = title.replace('$departureTime', departureTime);

    return {
      ...statusTemplate,
      title,
    };
  }

  getTimeLabel(time) {
    return time
      ? `at ${this.Utils.formatTime(time, this.Authentication.user.settings.usTimeFormat)}`
      : '';
  }

  _getStatusTemplate(event) {
    const clockInEnabled =
      this.Authentication.isOrgFeatureEnabled('clockIn') &&
      this.Authentication.user.orgSettings.clockInEnabled &&
      event.user.timeclockEnabled;

    return this.TimesheetsUtils.getRosterStatusTemplate({
      event,
      statusDict: ROSTER_STATUSES,
      noShowsEnabled: this.Authentication.isOrgFeatureEnabled('noShow'),
      sickCalloutEnabled: this.Authentication.isOrgFeatureEnabled('sickCallout'),
      hasToastIntegration: this.Authentication.user.org.hasToastIntegration,
      clockInEnabled,
    });
  }
}
